/**
* @version GENERATOR_VERSION::20200422
* @DateTime 2020-05-04T19:46:29.329
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listHouseRepeatPlanCondition,
	listHouseRepeatPlanConditionInit,
	listHouseRepeatPlanConditionByAuthorizations,
	deleteHouseRepeatPlanCondition
} from '@api/storagemanage/HouseRepeatPlanCondition';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listHouseRepeatPlanCondition({
			state
		}) {
			return new Promise((resolve, reject) => {
				listHouseRepeatPlanCondition(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listHouseRepeatPlanConditionByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listHouseRepeatPlanConditionByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listHouseRepeatPlanConditionInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listHouseRepeatPlanConditionInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteHouseRepeatPlanCondition({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteHouseRepeatPlanCondition({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
